import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  GetCountRestrictionsAPI,
  GetCountRestrictionsAPI2,
  getUserCrudAccess,
  userAccessAPI,
  userAccessAPI2,
  userCrudAccess,
  WSGetOrgUsers,
} from "../../../configs/WebService";
import axios from "axios";
import { apiKeyHeader } from "../../../configs/ApiKeys";
import { BASE_URL } from "../../../configs/WebServiceUrl";

export const createUser = createAsyncThunk(
  "user/createUser",
  async (userData, thunkAPI) => {
    try {
      const response = await axios.post(`${BASE_URL}/api/auth/signup`, userData, {
        headers: apiKeyHeader(),
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);
export const createTeacherUser = createAsyncThunk(
  "user/createTeacherUser",
  async (userData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/auth/teacher-user`,
        userData,
        { headers: apiKeyHeader() }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updateTeacherUser = createAsyncThunk(
  "user/updateTeacherUser",
  async (userData, thunkAPI) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/topic/updateTeacherUser`,
        userData,
        { headers: apiKeyHeader() }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const fetchOrgUsersById = createAsyncThunk(
  "user/fetchOrgUsersById",
  async (userId, { rejectWithValue }) => {
    try {
      // const res = await axios.get(`${WSGetOrgUsers}`, {
      //   headers: apiKeyHeader(),
      // });
      const res = await axios.get(
        `${BASE_URL}/api/auth/users/created-by/${userId}`,
        { headers: apiKeyHeader() }
      );
      return res?.data?.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const createCrudAccess = createAsyncThunk(
  "crudAccess/createCrudAccess",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      await axios.post(userCrudAccess, payload, { headers: apiKeyHeader() });
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const fetchUserCrudAccess = createAsyncThunk(
  "user/fetchUserCrudAccess",
  async (userId, thunkAPI) => {
    try {
      const response = await axios.get(
        // `http://localhost:5010/api/auth/user-crud-access/${userId}`
        `${getUserCrudAccess}/${userId}`,
        { headers: apiKeyHeader() }
      );
      console.log("ok", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const GetUserAccessThunk = createAsyncThunk(
  "user/GetUserAccessThunk",
  async (_, { rejectWithValue, getState, dispatch }) => {
    const user = getState().authSlice.user;

    await dispatch(GetCountRestrictionsThunk());

    try {
      // if (user.roles === "trial") {
      //   const response = await axios.get(userAccessAPI + user.id, {
      //     headers: apiKeyHeader(),
      //   });
      //   return response.data;
      // } else {
      //   return {};
      // }
      const response = await axios.get(userAccessAPI + user.id, {
        headers: apiKeyHeader(),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const GetCountRestrictionsThunk = createAsyncThunk(
  "user/GetCountRestrictionsThunk",
  async (_, { rejectWithValue, getState }) => {
    const user = getState().authSlice.user;

    try {
      const response = await axios.get(GetCountRestrictionsAPI + user.id, {
        headers: apiKeyHeader(),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const GetUserAccessThunk2 = createAsyncThunk(
  "user/GetUserAccessThunk2",
  async (_, { rejectWithValue, getState, dispatch }) => {
    const user = getState().authSlice.user;

    await dispatch(GetCountRestrictionsThunk2());

    try {
      // if (user.roles === "trial") {
      //   const response = await axios.get(userAccessAPI + user.id, {
      //     headers: apiKeyHeader(),
      //   });
      //   return response.data;
      // } else {
      //   return {};
      // }
      const response = await axios.get(userAccessAPI2 + user.id, {
        headers: apiKeyHeader(),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const GetCountRestrictionsThunk2 = createAsyncThunk(
  "user/GetCountRestrictionsThunk2",
  async (_, { rejectWithValue, getState }) => {
    const user = getState().authSlice.user;

    try {
      const response = await axios.get(GetCountRestrictionsAPI2 + user.id, {
        headers: apiKeyHeader(),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


// export const getWalkthroughStatusThunk= createAsyncThunk(
//   "user/getWalkthroughStatusThunk",
//   async (userId, thunkAPI) => {
//     try {
//       const response = await axios.get(
//         `${BASE_URL}/userAccess/getWalkthroughStatus/${userId}`,
//         { headers: apiKeyHeader() }
//       );
//       localStorage.setItem("walkthroughStatus", JSON.stringify(response.data));
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response.data);
//     }
//   }
// );

// export const updateWalkthroughStatusThunk= createAsyncThunk(
//   "user/updateWalkthroughStatusThunk",
//   async ({userId, module_id}, thunkAPI) => {
//     try {
//       const response = await axios.put(
//         `${BASE_URL}/api/userAccess/updateWalkthroughStatus`,
//         {user_id:userId,module_id},
//         { headers: apiKeyHeader() }
//       );
//       getWalkthroughStatusThunk(userId);
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response.data);
//     }
//   }
// );

export const fetchTeacherDetails = createAsyncThunk(
  "user/fetchTeacherDetails",
  async (teacherId, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/auth/teacher-details/${teacherId}`,
        { headers: apiKeyHeader() }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const unassignTeacherThunk = createAsyncThunk(
  "user/unassignTeacherThunk",
  async (teacherId, thunkAPI) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/api/auth/teacher/unassign/${teacherId}`,
        { headers: apiKeyHeader() }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchUserDetails = createAsyncThunk(
  "user/fetchUserDetails",
  async (userId, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/auth/user-details/${userId}`,
        { headers: apiKeyHeader() }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateUserPasswordThunk = createAsyncThunk(
  "user/updateUserPasswordThunk",
  async ({ userId, password, dbName }, thunkAPI) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/api/auth/user/update-password/${userId}?db_name=${encodeURIComponent(dbName)}`,
        { password },
        { headers: apiKeyHeader() }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);